import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconBaseballCap$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBaseballCap extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'bf716b4d0356357eb3ed736a1041fe36f249736d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '0c15abf1abfafde8058c60c88a5d16e4e5055f90', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'f9fa5d2af310d8f024297dc72fc83686133340dd', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15 12.024V11a5.82 5.82 0 0 0-6-6 5.83 5.83 0 0 0-6 6v1.6C3 13.93 5.68 15 9 15h3.973C18.31 15 20 14.639 20 13.5c0-.98-1.259-1.382-5-1.476m-10.5.427V11A4.353 4.353 0 0 1 9 6.5a4.3 4.3 0 0 1 4.5 4.5v1.45c-.371.389-1.978 1.05-4.5 1.05s-4.129-.661-4.5-1.05", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-baseball-cap", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-baseball-cap"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-baseball-cap":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBaseballCap$1);
            }
            break;
    } });
}

const CosmosIconBaseballCap = CosmosIconBaseballCap$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBaseballCap, defineCustomElement };
